import styled, { useTheme } from 'styled-components';

import TinyDropDown, { Props as TinyDropDownProps } from '~components/common/TinyDropDown';
import Tooltip from '~components/common/Tooltip';
import ExclamationMark from '~components/Icon/ExclamationMark';
import Text from '~components/Text';

interface Props extends Omit<TinyDropDownProps, '$width'> {
  tooltipText?: string;
  tooltipHelperText?: string;
  emptyValue?: string;
  isShowTooltip?: boolean;
}

export default function DropDownSource({
  value,
  emptyValue,
  options,
  isShowTooltip = true,
  tooltipText,
  tooltipHelperText,
  onChange,
}: Props) {
  const theme = useTheme();

  return (
    <Wrapper>
      {isShowTooltip && tooltipText && (
        <Tooltip tooltipText={tooltipText} position='center'>
          <ExclamationMark width={15} color={theme.colors.gray700} />
        </Tooltip>
      )}
      <TooltipHelperText typography='midium150_B3'>{tooltipHelperText}</TooltipHelperText>
      {emptyValue ? (
        <EmptyValue typography='midium150_B3'>{emptyValue}</EmptyValue>
      ) : (
        <TinyDropDown $width='80px' value={value} options={options} onChange={onChange} />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const TooltipHelperText = styled(Text)`
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.gray700};
`;

const EmptyValue = styled(Text)`
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.gray900};
  font-size: 14px;
`;
